import { Component, Inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { DwAuthenticationType, DwMenuHelperService, DwMenuService, DwMenuServiceState, DwSecurityUserService, DwAppInitService } from '@devwareapps/devware-cap';
import { AppDevwareConfigProviderService } from '../../app-devware-config-provider.service';
import { AppPermissions } from '../../meta-data/app-permissions.enum';
import { PilexosUser } from '../../features/shared/models/pilexos-user.model';
import { PilexosUserTypeIds } from '../../features/shared/models/pilexos-user-type.enum';
import { ExaminerRepositoryService } from '../../features/examiner/services/examiner-repository.service';
import { FlightSchoolTypeAllItems, PilotExaminerEntity, PilotExaminerStatusAllItems } from '../../meta-data/app-meta-data.service';
import { AdminManagerService } from '../../features/shared/services/admin-manager.service';
import { SchoolRepositoryService } from '../../features/schools/services/school-repository.service';
import { SchoolFeatures } from '../../features/schools/models/school-features.model';
import { delay, take } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  showLayout: boolean = true;

  showSlashScreen: boolean = true;
  environmentMessage: string;
  scrolled = false;

  themeClasses: string;
  lastExaminer: PilotExaminerEntity;
  logoutComplete: boolean;
  pilexosUser: PilexosUser;
  schoolfeatures: SchoolFeatures;
  isPilexosAdmin: any;

  constructor(
    private router: Router,
    private menuService: DwMenuService,
    private menuHelperService: DwMenuHelperService,
    private dwSecurityUserService: DwSecurityUserService,
    private dwAppInitService: DwAppInitService,
    private titleService: Title,
    private examinerRepository: ExaminerRepositoryService,
    private adminManagerService: AdminManagerService,
    private schoolRepositoryService: SchoolRepositoryService,
  ) {
    this.environmentMessage = AppDevwareConfigProviderService.getEnvironmentMessage();
  }

  ngOnInit(): void {
    this.titleService.setTitle(AppDevwareConfigProviderService.getEnvironmentBaseTitle());
    this.dwAppInitService.getAppInitResult()
      .pipe(take(1))
      .subscribe(appInitResult => {
        this.titleService.setTitle(
          AppDevwareConfigProviderService.getEnvironmentBaseTitleForRuntime(appInitResult?.EnvironmentInfo)
        );
      });

    setTimeout(() => {
      this.showSlashScreen = false;
    }, 200);

    document.addEventListener("scroll", (ev) => {
      let document = ev.target as any;
      if (document.scrollingElement.scrollTop > 50) {
        if (!this.scrolled) {
          this.scrolled = true;
          this.setTheme(this.menuService.menuState);
        }
      }
      else {
        if (this.scrolled) {
          this.scrolled = false;
          this.setTheme(this.menuService.menuState);
        }
      }
    });

    this.menuService.menuStateObservable
      .pipe(delay(10))
      .subscribe(menuState => {
        this.setTheme(menuState);
      })

    this.setTheme(this.menuService.menuState);

    this.dwSecurityUserService.securityContextChanged()
      .pipe(delay(10))
      .subscribe(() => {
        this.handleSecurityChange();
      });

    this.handleSecurityChange();
  }

  handleSecurityChange() {
    setTimeout(() => {


      const pilexosUser = this.adminManagerService.getPilexosUser();

      if (this.pilexosUser?.user?.UserId == pilexosUser?.user?.UserId && this.pilexosUser?.UserTypeId == pilexosUser?.UserTypeId && this.pilexosUser?.flightSchoolOrganizationId == pilexosUser?.flightSchoolOrganizationId) {
        return;
      }

      this.pilexosUser = pilexosUser;

      this.showSchoolName = false;

      const schoolUserTypes = [PilexosUserTypeIds.flightSchool, PilexosUserTypeIds.checkInstructor, PilexosUserTypeIds.flightInstructor];

      const isSchoolUser = schoolUserTypes.includes(pilexosUser?.UserTypeId);
      this.isPilexosAdmin = pilexosUser.hasPermission(AppPermissions.pilexosAdmin);

      if (isSchoolUser) {
        this.loadSchoolFeatures(true);
      }
    });
  }

  showSchoolName: boolean = false;
  schoolName: string;
  isOdaSchool: boolean = false;

  private checkPilotExaminerSecurity(menuState: DwMenuServiceState) {
    if (!(menuState?.currentMenu?.url?.indexOf('/settings') >= 0)) {
      return;
    }


    this.pilexosUser = this.adminManagerService.getPilexosUser();

    if (!this.pilexosUser) {
      return;
    }

    if (this.dwSecurityUserService.hasPermission(AppPermissions.pilexosUserTypeLimitedMenusCanSeeAll)) {
      return;
    }

    if (this.pilexosUser.UserTypeId != PilexosUserTypeIds.pilotExaminer) {
      this.router.navigate(['/']);
    }

    const menu = this.menuService.menuState.currentMenu;

    if (!menu) {
      console.log('menu not found');
    }

    if (!this.menuHelperService.canAccessMenu(menu)) {
      this.router.navigate(['/']);
    }

    if (!menu.data.visibleRuleResult) {
      this.router.navigate(['/']);
    }

    if (this.lastExaminer?.UserId == this.pilexosUser?.user?.UserId) {
      if ((this.lastExaminer.PilotExaminerStatusId == PilotExaminerStatusAllItems.VerifiedLive) || (this.lastExaminer.PilotExaminerStatusId == PilotExaminerStatusAllItems.Inactive)) {
        return;
      }
      this.router.navigate(['/']);

      return;
    }

    this.examinerRepository.getCurrentPilotExaminer()
      .subscribe(examiner => {

        this.lastExaminer = examiner;

        if ((examiner.PilotExaminerStatusId == PilotExaminerStatusAllItems.VerifiedLive) || (examiner.PilotExaminerStatusId == PilotExaminerStatusAllItems.Inactive)) {
          return;
        }
        this.router.navigate(['/']);
      })

  }
  loadSchoolFeatures(showSchoolNameAfter: boolean) {
    this.schoolRepositoryService.getSchoolFeatures()
      .subscribe(features => {

        setTimeout(() => {


          this.schoolfeatures = features;

          this.schoolName = this.schoolfeatures?.FlightSchoolName;
          this.isOdaSchool = this.schoolfeatures?.FlightSchoolTypeId === FlightSchoolTypeAllItems.ODA;

          if (showSchoolNameAfter && this.schoolName) {
            this.showSchoolName = true;
          }
        })
      });
  }

  private setTheme(menuState: DwMenuServiceState) {
    this.checkPilotExaminerSecurity(menuState);

    // deselect text

    const currentMenu = menuState.currentMenu;

    let themeClass: string = Themes.home;

    let themeClasses = themeClass;

    if (!currentMenu) {



      if (this.scrolled) {
        themeClasses += ',scrolled';
      }

      this.setThemeFinal(themeClasses);

      return;
    }

    themeClass = Themes.main;

    if (currentMenu.url?.indexOf('admin') >= 0) {
      themeClass = Themes.admin;
    }

    if (currentMenu.data?.referenceKey == 'home') {
      themeClass = Themes.home;
    }

    themeClasses = themeClass;

    if (this.scrolled) {
      themeClasses += ',scrolled';
    }

    this.setThemeFinal(themeClasses);

    if (!this.dwSecurityUserService.securityState.isAuthenticated) {

      if (this.dwSecurityUserService.securityState.authenticationType == DwAuthenticationType.logout && !this.logoutComplete) {

        setTimeout(() => {
          themeClasses += ',home-page-annonymous';

          this.setThemeFinal(themeClasses);

          //   this.themeClasses += ',home-page-annonymous';
          // console.log('theme Classes', this.themeClasses);
          this.logoutComplete = true;

        }, 250);
        return;
      } else {
        themeClasses += ',home-page-annonymous';

        this.setThemeFinal(themeClasses);

        //this.updateThemes(this.themeClasses, 'home-page-annonymous');
        //this.themeClasses += ',home-page-annonymous';
      }
    } else {
      this.logoutComplete = false;
    }
    //this.deselectText();
  }

  private setThemeFinal(themeClass: string) {
    setTimeout(() => {
      this.themeClasses = themeClass;
    }, 0);
  }

  private deselectText() {
    try {
      if (window.getSelection) {
        window.getSelection().removeAllRanges();
      }
      else
        if ((document as any).selection) {
          (document as any).selection.empty();
        }
    }
    catch (e) {

    }
  }

  changeFlightSchool() {
    this.adminManagerService.showUserTypeModal("Change Flight School").subscribe(result => {

    });
  }

  ngOnDestroy(): void {
    document.removeEventListener("scroll", (ev) => { });
  }
}


enum Themes {
  home = 'home-theme',
  main = 'main-theme',
  admin = 'admin-theme'
}
